/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */

/* eslint-disable max-len */
/* flow-disable */

import React, { PropTypes } from 'react';
import _ from 'lodash';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { connect } from 'react-redux';
import { runService } from '../../actions/eservices';
import CustomizedMap from './CustomizedMap';
import PowrotDoListyEuslug from '../../components/PowrotDoListyEuslug/PowrotDoListyEuslug';
import { isMobileView, isTabletView, renderHelpDesc } from '../../components/utils/utils';
import EmptyFileDownloader from '../../components/EmptyFileDownloader/EmptyFileDownloader';
import ServiceCardDownloader from '../../components/ServiceCardDownloader/ServiceCardDownloader';
import { DecisionContainer, PersonalDataContainer } from '../../containers';
import GrayPanel from '../../components/GrayPanel';
import history from '../../core/history';
import pans from './panStyle.scss';
import ModalAlert from './ModalAlert';
import v from './validators';
import s from './EServices.css';


const btnStyle = {
  borderRadius: 0,
  border: 'none',
  padding: '10px 40px',
  marginLeft: '10px',
};

const dealOptions = [
  {
    label: 'najem',
    value: 'najmu',
    state: 'rodzajUmowy',
  },
  {
    label: 'dzierżawa',
    value: 'dzierżawy',
    state: 'rodzajUmowy',
  },
  {
    label: 'użyczenie',
    value: 'użyczenia',
    state: 'rodzajUmowy',
  },
];

const workOptions = [
  {
    label: 'wydzierżawienie',
    value: 'Wydzierżawiony',
    state: 'rodzajDzialania',
  },
  {
    label: 'użyczenie',
    value: 'Użyczony',
    state: 'rodzajDzialania',
  },
];

const changeDict = {
  rodzajUmowy: {
    label: 'Rodzaj umowy',
    editable: true,
    type: 'Select',
    options: dealOptions,
  },
  miejscowosc: {
    label: 'Miejscowość',
    editable: true,
  },
  ulica: {
    label: 'Ulica',
    editable: true,
  },
  rodzajDzialania: {
    label: 'Rodzaj działania',
    editable: true,
    type: 'Select',
    options: workOptions,
  },
  przeznaczenie: {
    label: 'Przeznaczenie gruntu',
    editable: true,
    type: 'textarea',
  },
};

const customChangeDict = {
  okres: {
    label: 'Okres dzierżawy',
    editable: true,
  },
  ulica: {
    label: 'Ulica',
    editable: true,
  },
  przeznaczenie: {
    label: 'Cel dzierżawy',
    editable: true,
    type: 'textarea',
  },
};

const disabledContactDict = {
  mailAddress: {
    label: 'Adres korespondencyjny',
    editable: false,
    type: 'textarea',
  },
};

const contactDict = {
  mailAddress: {
    label: 'Adres korespondencyjny',
    editable: true,
    type: 'textarea',
  },
};


class PrzedluzenieUmowyNieruchomosci extends React.Component {
  state = {
    info: {
      rodzajUmowy: null,
      miejscowosc: null,
      ulica: null,
      rodzajDzialania: null,
      przeznaczenie: null,
      mailAddress: null,
      okres: null,
    },
    customLayout: this.props.district == '1818011',
    contactAsUser: false,
    selectedRoads: [],
    errors: {},
    errorTitle: '',
    errorText: '',
    showError: false,
    attachments: null,
    eserviceDistrict: null,
    selectedParcels: [],
    isMounted: false,
  };

  validators = {
    rodzajUmowy: [v.NotSelected],
    miejscowosc: [v.NotNull],
    ulica: [],
    rodzajDzialania: [v.NotSelected],
    przeznaczenie: [v.NotNull],
    mailAddress: [v.NotNull],
    okres: [],
  };

  nextStep = '/eservices/eserviceSummary/';

  onHide = () => this.setState({ showError: false });

  componentDidMount() {
    fetch(`${process.env.API_URL}/eservice/${this.props.district}/${this.props.query.serviceType}`)
      .then(r => r.json())
      .then(resp => {
        this.setState({
          eserviceDistrict: resp,
        }, () => this.updateValidators());
      });

    this.setState({ isMounted: true });
  }

  updateValidators = () => {
    if (this.state.customLayout) {
      this.validators.rodzajUmowy = [];
      this.validators.miejscowosc = [];
      this.validators.ulica = [];
      this.validators.rodzajDzialania = [];
      this.validators.przeznaczenie = [v.NotNull];
      this.validators.mailAddress = [];
      this.validators.okres = [v.NotNull];
    } else {
      this.validators.rodzajUmowy = [v.NotSelected];
      this.validators.miejscowosc = [v.NotNull];
      this.validators.ulica = [];
      this.validators.rodzajDzialania = [v.NotSelected];
      this.validators.przeznaczenie = [v.NotNull];
      this.validators.mailAddress = [v.NotNull];
      this.validators.okres = [];
    }
  }

  setParcels = (parcels, callback = null) => this.setState({ selectedParcels: parcels });

  onChange = (e, group) => {
    const name = e.target.name;
    this.setState(
      {
        [group]: {
          ...this.state[group],
          [name]: e.target.value,
        },
      },
      () => this.validate(group, name),
    );
  };

  onChangeSelect = (e, group) => {
    const name = e.state;
    this.setState(
      {
        [group]: {
          ...this.state[group],
          [name]: e.value,
        },
      },
      () => this.validate(group, name),
    );
  };

  changeContactData = () => this.setState({ contactAsUser: !this.state.contactAsUser }, () => this.onChangeContact());

  onChangeContact = () => {
    let mailAddress = null;
    if (this.state.contactAsUser) {
      const { AddressFlat, AddressCity, AddressStreet, AddressNumber, AddressZipCode, AddressMail } = this.props.serviceInfo.user;
      const street = AddressStreet ? 'ul.' + AddressStreet + ' ' : ''

      if (AddressFlat) {
        mailAddress = `${AddressCity} ${street}${AddressNumber}/${AddressFlat}, ${AddressZipCode} ${AddressMail}`;
      } else {
        mailAddress = `${AddressCity} ${street}${AddressNumber}, ${AddressZipCode} ${AddressMail}`;
      }
    } else {
      mailAddress = null;
    }
    this.setState(
      {
        info: {
          ...this.state.info,
          mailAddress,
        },
      },
      () => this.validate('info', 'mailAddress'),
    );
  };

  validateField = (group, field) => {
    const checks = [];
    if (Object.keys(this.validators).indexOf(field) > -1) {
      for (const validator of this.validators[field]) {
        const check = validator(this.state[group][field]);
        if (check) checks.push(check);
      }
    }
    return checks;
  };

  validateGroup = group => {
    const fields = Object.keys(this.state[group]);
    const errors = {};
    for (const f of fields) {
      const checks = this.validateField(group, f);
      errors[f] = checks;
    }
    return errors;
  };

  validate = (group, field = null, callback = null) => {
    let newState = null;
    if (field) {
      if (Object.keys(this.validators).indexOf(field) > -1) {
        const checks = this.validateField(group, field);
        newState = {
          errors: {
            ...this.state.errors,
            [field]: checks,
          },
        };
      }
    } else if (group) {
      const errors = this.validateGroup(group);
      newState = { errors };
    } else {
      let errors = {};
      const grupy = ['info'];
      for (const g of grupy) {
        const err = this.validateGroup(g);
        errors = { ...errors, ...err };
      }
      newState = { errors: { ...errors } };
    }
    if (newState) {
      if (callback) {
        this.setState(newState, callback);
      } else {
        this.setState(newState);
      }
    }
  };

  haseErrors = () => {
    for (const key of Object.keys(this.state.errors)) {
      if (this.state.errors[key].length > 0) return true;
    }
    return false;
  };

  insertTestData = () => {
    this.setState({
      info: {
        miejscowosc: 'Olesno',
        ulica: 'Testowa',
        przeznaczenie: 'Przeznaczenie testowe',
      },
    });
  };

  postValidation = () => {
    const hasFieldErrors = this.haseErrors();
    if (this.state.customLayout && !this.state.selectedParcels.length) {
      return this.setState({
        errorText: 'Nie wybrano działki ewidencyjnej. Prosimy o wskazanie działki',
        errorTitle: 'Błędnie wypełniony formularz',
        showError: true,
      });
    }

    if (hasFieldErrors) {
      this.setState({
        errorText: 'Uzupełnij pola obowiązkowe.',
        errorTitle: 'Błędnie wypełniony formularz.',
        showError: true,
      });
      return;
    }

    if (!hasFieldErrors) {
      this.props
        .runService(this.props.serviceInfo.eservice.shortName, this.props.district, {
          info: { ...this.state.info },
          dzialki: this.state.selectedParcels,
          selectedParcels: this.state.selectedParcels,
          user: {
            ...this.props.serviceInfo.user,
          },
          shortName: this.props.serviceInfo.eservice.shortName,
          urzad: this.props.districts[this.props.prefix],
          attachments: this.state.attachments,
        })
        .then(resp => {
          this.redirectToSummary(resp.jobId);
        });
    }
  };

  redirectToSummary = (jobId) => {
    window.location.href = `${this.nextStep}${jobId}`;
  };

  startService = () => {
    this.validate(null, null, this.postValidation);
  };

  render() {
    const isMobile = this.state.isMounted && isMobileView(window);
    const isTablet = this.state.isMounted && isTabletView(window);
    return (
      <div style={{ paddingTop: '20px' }}>
        <h3 style={{ textAlign: 'center' }}>
          {this.props.serviceInfo.eservice.title}
        </h3>
        <PersonalDataContainer userData={this.props.serviceInfo.user} />

        {this.state.customLayout ?
          <GrayPanel
            title={'1. Adres'}
          >
            { renderHelpDesc(isMobile, isTablet) }
            <CustomizedMap
              serviceType={this.props.serviceInfo.eservice.shortName}
              setParcels={this.setParcels}
              setSelectDzialki={this.setSelectDzialki}
              selectedParcels={this.state.selectedParcels}
              obreby={this.props.serviceInfo.precints}
              district={this.props.districts[this.props.prefix]}
              prefix={this.props.prefix}
              mapState={this.props.mapstates[0]}
              settings={this.props.serviceInfo.eservice.mapConfig}
              dokumentType={this.props.serviceInfo.eservice}
            />
          </GrayPanel> : null}

        {this.state.customLayout ? null :
          <GrayPanel
            title={'1. Adres korespondencyjny'}
          >
            <div className={s.subtitle}>
              <input
                id="contactCheckbox"
                name="isDefault"
                type="checkbox"
                value={this.state.contactAsUser}
                onChange={this.changeContactData}
              />
              <label htmlFor="contactCheckbox">&nbsp;&nbsp;Taki jak wnioskodawcy</label>
            </div>
            {this.state.contactAsUser ?
              <DecisionContainer
                title={''}
                data={this.state.info}
                errors={this.state.errors}
                formDict={disabledContactDict}
                onChange={e => this.onChange(e, 'info')}
              /> :
              <DecisionContainer
                title={''}
                data={this.state.info}
                errors={this.state.errors}
                formDict={contactDict}
                onChange={e => this.onChange(e, 'info')}
              /> }
          </GrayPanel>
        }

        <DecisionContainer
          title={'2. Informacje'}
          data={this.state.info}
          errors={this.state.errors}
          formDict={this.state.customLayout ? customChangeDict : changeDict}
          onChange={e => this.onChange(e, 'info')}
          onChangeSelect={e => this.onChangeSelect(e, 'info')}
        />

        <ModalAlert
          title={this.state.errorTitle}
          bodyText={this.state.errorText}
          show={this.state.showError}
          name="errorModal"
          onHide={this.onHide}
        />

        {/* BUTTONS */}
        <div className="row mobile-row">
          <div className="col-sm-12">
            <PowrotDoListyEuslug position="left" prefix={this.props.prefix} />
            <EmptyFileDownloader position="left" prefix={this.props.prefix} serviceType={this.props.serviceInfo.eservice.shortName} />
            {this.props.prefix === 'gmina_olesno_powiat_oleski' ?
              <ServiceCardDownloader position="left" prefix={this.props.prefix} serviceType={this.props.serviceInfo.eservice.shortName} />
              : null}
            <button
              type="submit-lg"
              className={this.props.isDisabled ? 'btn btn-primary disabled' : 'btn btn-primary'}
              style={{ float: 'right', marginRight: '15px', ...btnStyle }}
              onClick={() => this.setState({ loading: true }, () => this.startService())}
            >
              Uruchom
            </button>
            {_.includes(this.props.serviceInfo.user.roles, 'superadmin') ? (
              <button
                type="submit-lg"
                className="btn btn-success"
                style={{ float: 'right', marginRight: '15px', ...btnStyle }}
                onClick={this.insertTestData}
              >
                Insert Test Data
              </button>
            ) : null}
            <button
              type="submit-lg"
              className="btn btn-default"
              style={{ float: 'right', marginRight: '15px', ...btnStyle }}
              onClick={history.goBack}
            >
              Anuluj
            </button>
          </div>
        </div>
      </div>
    );
  }
}

PrzedluzenieUmowyNieruchomosci.propTypes = {
  serviceInfo: PropTypes.object,
  district: PropTypes.string,
};

const mapState = state => ({
  current_service: state.eservices.current,
  districts: state.district.districts
});

const mapDispatch = {
  runService,
};

export default withStyles(pans)(
  connect(
    mapState,
    mapDispatch,
  )(PrzedluzenieUmowyNieruchomosci),
);



// WEBPACK FOOTER //
// src/routes/eservices/PrzedluzenieUmowyNieruchomosci.js